import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom'
import AppRouter from './components/AppRouter';
import { Container } from '@mui/material';
import { appContext } from "./context/index";
import FooterOnPage from './components/UI/FooterOnPage';


const App = () => {
  const [theme, setTheme] = useState(0);
  return (
    <appContext.Provider value={{
      theme,
      setTheme
    }}>
      <BrowserRouter>
        <Container maxWidth="lg">
          <AppRouter />
          <FooterOnPage />
        </Container>
      </BrowserRouter>
    </appContext.Provider>
  );
}

export default App;